<script setup>
/**
 * 「联系客服」页，逐条对齐旧版 web/38.3b41921235118cc2e7f5.js 里的
 * app-service 组件（类 r、模板工厂 f + 子模板 h、样式 g）。
 *
 * 旧版整页只有一张客服二维码图：
 *   ngOnInit → getServiceWechatPic()
 *     _configApi.getConfig('service_wechat_pic') → POST /config/detail {name}
 *     成功把 data（图片地址字符串）存到 service_wechat_pic
 *
 *   ion-header > ion-toolbar
 *     ion-buttons[slot=start] > ion-button(click="nav.back()") > ion-icon[name=arrow-back]
 *     ion-title "联系客服"
 *   ion-content[padding]
 *     *ngIf="service_wechat_pic" → div.service-img > img [src]="service_wechat_pic"
 *
 *   样式 g：
 *     .service-img{text-align:center}
 *     .service-img img{max-width:100%}
 *
 * 旧版这里是独立路由页（不在 tabs 内），所以没有底部导航栏；
 * 返回按钮走的是 nav.back()（浏览器历史后退），不是固定跳某个路由。
 */
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { request } from '../services/api'

const router = useRouter()

// 旧版 this.service_wechat_pic，取不到就整块不渲染
const serviceWechatPic = ref('')

/** 旧版 getServiceWechatPic() */
async function getServiceWechatPic() {
  try {
    const response = await request('/config/detail', { method: 'POST', data: { name: 'service_wechat_pic' } })
    serviceWechatPic.value = typeof response.data === 'string' ? response.data : ''
  } catch (_) {
    // 旧版走 errorHandler 弹 toast，这里没有全局 toast，保持内容区空白即可
  }
}

/** 旧版 ion-button 的 (click)="nav.back()" */
function goBack() { router.back() }

onMounted(() => { void getServiceWechatPic() })
</script>

<template>
  <div class="service-page">
    <!-- 旧版 ion-header > ion-toolbar。红底白字来自主题模块注入 :root 的
         --ion-toolbar-background:#f95454 / --ion-toolbar-color:#fff（见 base.css 注释）。
         标题居中不是 Ionic md 的默认值（md 的 ion-title 没有 text-align，默认左对齐），
         而是 main.js 里主题 CSS 的全局 ion-title 覆盖所致；那条规则的具体内容
         因为工具无法按偏移读取单行大文件而未能取出，这里按截图实测的居中效果处理。 -->
    <header class="modal-header">
      <button class="modal-back" type="button" aria-label="返回" @click="goBack">
        <svg class="modal-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor" /></svg>
      </button>
      <h1 class="modal-title">联系客服</h1>
      <span class="modal-spacer" aria-hidden="true"></span>
    </header>

    <!-- 旧版 ion-content[padding]：utilities 把四边 --padding-* 设成 var(--ion-padding,16px) -->
    <div class="modal-content">
      <div v-if="serviceWechatPic" class="service-img">
        <img :src="serviceWechatPic" alt="" />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 页面外壳与顶栏跟牌九各弹窗保持一致 */
.service-page{position:fixed;z-index:1;top:0;left:0;width:100%;height:100%;background:#fff;color:#000;display:flex;flex-direction:column;font:14px Arial,"Microsoft YaHei",sans-serif}
.modal-header{display:flex;align-items:center;height:56px;background:var(--legacy-theme,#f95454);color:var(--legacy-toolbar-color,#fff);position:relative;z-index:1;box-shadow:0 2px 4px rgb(0 0 0 / 20%)}
.modal-back{display:flex;align-items:center;justify-content:center;width:56px;height:56px;border:0;background:transparent;line-height:1;color:inherit;cursor:pointer;padding:0}
.modal-back .modal-icon{width:24px;height:24px;display:block}
.modal-title{flex:1;margin:0;font-size:18px;font-weight:500;text-align:center;color:inherit}
.modal-spacer{width:56px;flex:none}
.modal-content{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px}

/* --- 逐条照抄旧版样式表 g（chunk 38） --- */
.service-img{text-align:center}
.service-img img{max-width:100%}
</style>
